import React from 'react'

import LibraryBooksOutlinedIcon from '@material-ui/icons/LibraryBooksOutlined'

import NavTabs from 'ui/components/NavTabs'
import { NEWS_PATHS } from 'utils/constants/routerPaths'

export default function ({ currentPath }) {
  return (
    <NavTabs
      title="Destaques e Notícias"
      icon={<LibraryBooksOutlinedIcon fontSize="small" />}
      paths={NEWS_PATHS}
      currentPath={currentPath}
    />
  )
}
